<template>
  <div id="contenedor-main-expediente-contrato">
    <expediente
      :idReferencia="idReferencia" moduloExpedienteOrigen="contratos">
    </expediente>
  </div>
</template>

<script>
import Expediente from '@/views/administracion/expedientes/Main.vue';

export default {
  name: 'ExpedienteContratoMain',
  components: {
    Expediente,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },
};
</script>

<style>
</style>
